module.exports = __webpack_public_path__ + "img/emoticon-csat-4-off.64f470b4.svg";